export default "__VITE_ASSET__DGhYqHup__"